import { render } from "./StoreButton.vue?vue&type=template&id=912fcf70&scoped=true"
import script from "./StoreButton.vue?vue&type=script&lang=js"
export * from "./StoreButton.vue?vue&type=script&lang=js"

import "./StoreButton.vue?vue&type=style&index=0&id=912fcf70&scoped=true&lang=css"

import exportComponent from "E:\\GoWorkSpace2\\src\\storedisk\\storedisk\\storedisk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912fcf70"]])

export default __exports__